module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-57x57-9462322d453dc90b8433fc8c9d6c067d.png";